
import {config} from "../config";
import * as error from "../error";
import { HttpResource } from "../resources/http.resource";
const auth0Host = "https://" + config.auth0Host + "/";

/**
 * Given a function f which can return a 429 from Auth0 to its callback,
 * this function returns a new function which handles those 429s and injects a retry logic.
 * So f may be called multiple times, but the callback will only be called once
 *
 * you will now write "(retryWithRateLimit(f))(callback)"
 *
 * @param f
 */
var _retryWrap = function (f) {

    var computeRetryTime = function (requestTimestamp, resHeaders) {

        resHeaders = resHeaders || {};


        //If we have a date from the server, use that instead of the request timestamp to we dont have
        //to guess the clock skew
        if (resHeaders.date) {
            try {
                //console.log("from server date");
                requestTimestamp = (new Date(resHeaders.date)).getTime();
            }
            catch (e) {
                //Add 10 seconds to account for clock skew
                requestTimestamp = requestTimestamp + 4000;
            }
        }

        //console.log(new Date(requestTimestamp), requestTimestamp);

        //Time at which we will try again
        var attemptsLimit = 10;
        var attemptsRemaining = 0;
        var attemptsResetAt = requestTimestamp + 60000 * attemptsLimit;
        var attemptsToRecover = 2;

        var xRateLimitReset = parseInt(resHeaders["X-RateLimit-Reset".toLowerCase()]);
        if (xRateLimitReset) {
            attemptsResetAt = xRateLimitReset * 1000;
        }

        var xRateLimitLimit = parseInt(resHeaders["X-RateLimit-Limit".toLowerCase()]);
        if (xRateLimitLimit) {
            attemptsLimit = xRateLimitLimit;
        }

        var xRateLimitRemaining = parseInt(resHeaders["X-RateLimit-Remaining".toLowerCase()]);
        if (xRateLimitRemaining) {
            attemptsRemaining = xRateLimitRemaining;
        }

        //Assuming that the limit will be linearly restore
        var attemptsRecoverable = attemptsLimit - attemptsRemaining;

        var timeToFullRecovery = (attemptsResetAt - requestTimestamp);

        var timeToFirstRecovery = (timeToFullRecovery/attemptsRecoverable);
        var timeToRequiredRecovery = timeToFirstRecovery * attemptsToRecover;

        //console.log("ttreset", timeToRequiredRecovery + 500);
        return timeToRequiredRecovery + 500;
    };

    return function (...args) {

        //console.log("!!!!!!!!");
        //Capture the calling context
        var This = this;
        var clientArgs = Array.prototype.slice.call(arguments);

        var lastCallTime;
        var doCall = function () {
            lastCallTime = Date.now();
            //console.log("doCall", lastCallTime);
            f.apply(This, clientArgs);
        };

        var clientCallback = clientArgs[clientArgs.length - 1];

        //Replace the client callback with our callback
        clientArgs[clientArgs.length - 1] = function (err) {
            if (err && err.statusCode === 429) {
                var ttNextCall = computeRetryTime(lastCallTime, err.headers);
                console.warn("Retrying auth0 api call after: " + ttNextCall/1000 + "secs");
                return setTimeout(doCall, ttNextCall);
            }

            //console.log("forwarding", Date.now());
            clientCallback.apply(this, arguments);
        };

        doCall();
    };
};

var jsonParseAndCallback = function (callback, err, res) {


    if (err) {
        return setImmediate(callback.bind(null, err));
    }
    // if (
    //     res.statusCode !== 201 &&
    //     res.statusCode !== 400 &&
    //     res.statusCode !== 401 &&
    //     res.statusCode !== 404 &&
    //     res.statusCode !== 429 &&
    //     res.statusCode !== 200
    // ) {
    //     err = new error.server.BadGateway("Unknown response code " + res.statusCode + " from auth 0");
    //     return setImmediate(callback.bind(null, err));
    // }

    // if(res.statusCode === 201) {
    //     return setImmediate(callback.bind(null, null, body));
    // }

    // if (res.statusCode === 400) {
    //     err = new error.client.BadRequest(body.message);
    //     return setImmediate(callback.bind(null, err));
    // }

    // if (res.statusCode === 401) {
    //     err = new error.client.Unauthorized("User not authorized: " + body);
    //     return setImmediate(callback.bind(null, err));
    // }

    // if (res.statusCode === 404) {
    //     err = new error.client.NotFound("Not found: " + body);
    //     return setImmediate(callback.bind(null, err));
    // }

    // if (res.statusCode === 429) {
    //     err = new error.client.TooManyRequests("Too Many Requests: " + body);

    //     err.headers = res.headers
    //     return setImmediate(callback.bind(null, err));
    // }

    // var obj;
    // try {
    //     obj = JSON.parse(res);
    // }
    // catch (err_) {
    //     obj = res;
    // }
    return setImmediate(callback.bind(null, null, res));
};

const http = new HttpResource();
http.setBaseUrl(auth0Host)

export const delegate_withRefreshToken = _retryWrap(function (refreshToken, options, callback) {
    const url = {
        pathname: ['delegation'],
        qs: {
            client_id: options.srcClientId,
            grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
            target: options.dstClientId,
            scope: options.scope || "openid",
            api_type: options.apiType || "app",
            refresh_token: refreshToken
        }
    }
    return http.post(http.parseOptions(url).url)
        .then(res => {
            return jsonParseAndCallback(callback, null, res)
        })
        .catch(err => {
            return jsonParseAndCallback(callback, err, null)
        })
    // return request({
    //     url: auth0Host + "/delegation",
    //     method: "POST",
    //     withCredentials: false,
    //     qs: {
    //         client_id: options.srcClientId,
    //         grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
    //         target: options.dstClientId,
    //         scope: options.scope || "openid",
    //         api_type: options.apiType || "app",
    //         refresh_token: refreshToken
    //     }
    // }, jsonParseAndCallback.bind(null, callback));
});

export const delegate_withIdToken = _retryWrap(function (idToken, options, callback) {
    const url = {
        pathname: ['delegation'],
        qs: {
            client_id: options.srcClientId,
            grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
            target: options.dstClientId,
            scope: options.scope || "openid",
            api_type: options.apiType || "app",
            id_token: idToken
        }
    }
    return http.post(http.parseOptions(url).url)
        .then(res => {
            return jsonParseAndCallback(callback, null, res)
        })
        .catch(err => {
            return jsonParseAndCallback(callback, err, null)
        })
    // return request({
    //     url: auth0Host + "/delegation",
    //     method: "POST",
    //     withCredentials: false,
    //     qs: {
    //         client_id: options.srcClientId,
    //         grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
    //         target: options.dstClientId,
    //         scope: options.scope || "openid",
    //         api_type: options.apiType || "app",
    //         id_token: idToken
    //     }
    // }, jsonParseAndCallback.bind(null, callback));
});

// export const getUserContactInfo = function (tokenGenerator, memberId, callback) {
//     var payload = {
//         "scopes": {
//             "users": {
//                 "actions": [
//                     "read"
//                 ]
//             }
//         }
//     };
//     tokenGenerator.setPayload(payload);
//     var token = tokenGenerator.generateToken();

//     return request(
//         {
//             url: auth0Host + "/api/v2/users/" + memberId,
//             method: "GET",
//             headers: {
//                 Authorization: "Bearer " + token.token()
//             },
//             qs: {
//                 id_token: token.token()
//             },
//         },
//         jsonParseAndCallback.bind(null, callback)
//     );
// };

// export const editUserInfo = function (tokenGenerator, memberId, data, callback) {
//     var payload = {
//         "scopes": {
//             "users": {
//                 "actions": [
//                     "update"
//                 ]
//             }
//         }
//     };
//     tokenGenerator.setPayload(payload);
//     var token = tokenGenerator.generateToken();

//     return request(
//         {
//             url: auth0Host + "/api/v2/users/" + memberId,
//             method: "PATCH",
//             headers: { Authorization: "Bearer " + token.token() },
//             qs: { id_token: token.token() },
//             json: data,
//         },
//         jsonParseAndCallback.bind(null, callback)
//     );
// };

// export const blockUserById = function(tokenGenerator, userId, callback) {
//     const payload = {
//         "scopes": {
//             "users": {
//                 "actions": [
//                     "update"
//                 ]
//             }
//         }
//     };

//     tokenGenerator.setPayload(payload);
//     const token = tokenGenerator.generateToken();

//     return request(
//         {
//             url: `${auth0Host}/api/v2/users/${userId}`,
//             method: "PATCH",
//             headers: {Authorization: "Bearer " + token.token()},
//             json: {"blocked": true}
//         }, jsonParseAndCallback.bind(null, callback));
// };

// export const generateVerificationUrl = function(tokenGenerator, userId, resultUrl, callback) {
//     const payload = {
//         "scopes" : {
//             "user_tickets": {
//                 "actions": ["create"]
//             }
//         }
//     };

//     tokenGenerator.setPayload(payload);
//     const token = tokenGenerator.generateToken();

//     return request({
//         url: `${auth0Host}/api/v2/tickets/email-verification`,
//         method: "POST",
//         headers: {
//             Authorization: "Bearer " + token.token()
//         },
//         json: {
//             "user_id": userId,
//             "result_url": resultUrl
//         }
//     }, jsonParseAndCallback.bind(null, callback));
// };

// export const getMultipleUserInfo = function(tokenGenerator, usersArray, fieldsArray, callback) {
//     fieldsArray.push("user_id");
//     var queryStringUsers = usersArray.map(function(item) {return '"' + item + '"'}).join("OR");
//     var payload = {
//         "scopes" : {
//             "users" : {
//                 "actions" : [
//                     "read"
//                 ]
//             }
//         }
//     };
//     tokenGenerator.setPayload(payload);
//     var token = tokenGenerator.generateToken();

//     return request({
//             url: auth0Host + "/api/v2/users",
//             method: "GET",
//             headers: {
//                 Authorization: "Bearer " + token.token()
//             },
//             qs: {
//                 fields : fieldsArray.join(","),
//                 q: queryStringUsers,
//                 search_engine: "v2"
//             }
//         },
//         jsonParseAndCallback.bind(null, callback));
// };

export const tokenInfo = function (idToken, callback) {
    const url = {
        pathname: ['tokeninfo'],
        qs: {
            id_token: idToken
        }
    }
    return http.post(http.parseOptions(url).url)
        .then(res => {
            return jsonParseAndCallback(callback, null, res)
        })
        .catch(err => {
            return jsonParseAndCallback(callback, err, null)
        })
    // return request({
    //     url: auth0Host + "/tokeninfo",
    //     method: "POST",
    //     withCredentials: false,
    //     qs: {
    //         id_token: idToken
    //     }
    // }, jsonParseAndCallback.bind(null, callback));
};

